(function($) {
	
	const checkbox = document.getElementById("agreed-to-terms-checkbox");
	const download_button = document.getElementById("download-button");
	
	checkbox.onclick = function() {
		const is_checked = this.checked;
		if (is_checked) {
			download_button.classList.remove("disabled");
		} else {
			download_button.classList.add("disabled");
		}
	};
	
})(jQuery);